export default __webpack_public_path__ + "static/media/left-arrow.6d322e7d.svg";